export default {
  title: "الإعدادات",
  subtitle: "إدارة إعدادات خدمات الموقع",
  
  sections: {
    general: "الإعدادات العامة",
    appearance: "المظهر",
    notifications: "الإشعارات",
    security: "الأمان",
    integrations: "التكاملات الخارجية",
    advanced: "متقدم"
  },
  
  fields: {
    siteName: "اسم الموقع",
    siteDescription: "وصف الموقع",
    language: "اللغة الافتراضية",
    timezone: "المنطقة الزمنية",
    currency: "العملة الافتراضية",
    theme: "المظهر",
    emailNotifications: "إشعارات البريد الإلكتروني",
    smsNotifications: "إشعارات الرسائل النصية",
    twoFactorAuth: "المصادقة الثنائية",
    sessionTimeout: "انتهاء صلاحية الجلسة",
    maxLoginAttempts: "الحد الأقصى لمحاولات تسجيل الدخول",
    passwordPolicy: "سياسة كلمة المرور",
    backupFrequency: "تكرار النسخ الاحتياطي",
    maintenanceMode: "وضع الصيانة"
  },
  
  placeholders: {
    siteName: "أدخل اسم الموقع",
    siteDescription: "أدخل وصف الموقع",
    sessionTimeout: "أدخل المهلة بالدقائق"
  },
  
  messages: {
    updateSuccess: "تم تحديث الإعدادات بنجاح",
    updateError: "فشل في تحديث الإعدادات",
    resetSuccess: "تم إعادة تعيين الإعدادات إلى الافتراضية",
    resetError: "فشل في إعادة تعيين الإعدادات",
    resetConfirm: "هل أنت متأكد من إعادة تعيين جميع الإعدادات إلى الافتراضية؟",
    loadingSettings: "جاري تحميل الإعدادات...",
    fetchError: "فشل في جلب الإعدادات"
  },
  
  validation: {
    siteNameRequired: "اسم الموقع مطلوب",
    sessionTimeoutMin: "انتهاء صلاحية الجلسة يجب أن يكون 5 دقائق على الأقل",
    sessionTimeoutMax: "انتهاء صلاحية الجلسة يجب ألا يتجاوز 1440 دقيقة"
  },
  
  actions: {
    save: "حفظ الإعدادات",
    reset: "إعادة تعيين إلى الافتراضي",
    export: "تصدير الإعدادات",
    import: "استيراد الإعدادات"
  },
  
  themes: {
    light: "فاتح",
    dark: "داكن",
    auto: "تلقائي"
  },
  
  frequencies: {
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري"
  },
  
  breadcrumbs: {
    settings: "الإعدادات",
    general: "عام",
    appearance: "المظهر",
    notifications: "الإشعارات",
    security: "الأمان"
  }
};
